import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../fb";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  Paper,
  Avatar,
} from "@mui/material";
import logo from '../img/logo.png';

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const login = async () => {
    setMessage("");
    setError(false);
    setLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      setMessage(`Bem-vindo, ${user.email}`);

      window.location='/'

      setError(false);
    } catch (err) {
      setMessage(`Erro: ${err.message}`);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#f5f5f5",
        p: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{ p: 4, maxWidth: 400, width: "100%", borderRadius: 3 }}
      >
        {/* Logotipo */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <Avatar
            src={logo}
            alt="Logotipo"
            sx={{ width: 100, height: 150 }}
          />
        </Box>
        {message && (
          <Alert severity={error ? "error" : "success"} sx={{ mb: 2 }}>
            {message}
          </Alert>
        )}

        {/* Formulário */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={login}
            disabled={loading}
            fullWidth
          >
            {loading ? "A carregar..." : "Login"}
          </Button>
        </Box>
        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          <a href="#" style={{ textDecoration: "none", color: "#1976d2" }}>
            Esqueceu a senha?
          </a>
        </Typography>
      </Paper>
    </Box>
  );
}
